import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import {
    TAXRATES_ALL_RECEIVED,
    TAXRATES_FAILED,
    TAXRATES_RECEIVED,
    TAXRATES_REQUEST,
    TAXRATE_CREATE,
    TAXRATE_CREATED,
    TAXRATE_DELETE,
    TAXRATE_UPDATE,
} from './tax-rates-actions';
import { TaxRate } from '../../../../../common/models/tax-rate';

export interface TaxRatesReducerState {
    taxRates: PaginatedResponse<TaxRate>;
    allTaxRates: TaxRate[];
    requesting: boolean;
}

export const initialTaxRatesReducerState: TaxRatesReducerState = {
    taxRates: { items: [], limit: 0, page: 0, total: 0 },
    allTaxRates: [],
    requesting: false,
};

export const taxRatesReducer = (
    state: TaxRatesReducerState = initialTaxRatesReducerState,
    action: AnyAction
): TaxRatesReducerState => {
    const { type } = action;

    switch (type) {
        case TAXRATE_CREATE:
        case TAXRATES_REQUEST: {
            return {
                ...state,
                requesting: true,
            };
        }

        case TAXRATES_RECEIVED: {
            return {
                ...state,
                taxRates: action['taxRates'],
                requesting: false,
            };
        }

        case TAXRATES_ALL_RECEIVED: {
            return {
                ...state,
                allTaxRates: action['taxRates'],
                requesting: false,
            };
        }

        case TAXRATES_FAILED: {
            return {
                ...state,
                requesting: false,
            };
        }

        case TAXRATE_DELETE: {
            return {
                ...state,
                taxRates: {
                    ...state.taxRates,
                    items: state.taxRates.items.filter((taxrate: TaxRate) => taxrate.id !== action['taxRateId']),
                    total: state.taxRates.total - 1,
                },
            };
        }

        case TAXRATE_UPDATE: {
            return {
                ...state,
                taxRates: {
                    ...state.taxRates,
                    items: state.taxRates.items.map((taxRate: TaxRate) => {
                        if (taxRate.id === action['taxRate'].id) {
                            return action['taxRate'];
                        }
                        return taxRate;
                    }),
                },
            };
        }

        case TAXRATE_CREATED: {
            return {
                ...state,
                taxRates: {
                    ...state.taxRates,
                    items: [action['taxRate'], ...state.taxRates.items],
                },
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
